/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of ViewportUtils
 */

import { IViewportExtraAttrs } from 'com/didichuxing/tracker/h5/plugins/utils/IViewportExtraAttrs';
import { IObjectMap } from 'com/didichuxing/IObjectMap';

export default abstract class ViewportUtils {

    /**
     * 获取Viewport 盒模型属性。
     * @param {Window} viewport
     * @returns {IViewportExtraAttrs}
     */
    public static getViewportBox(viewport: Window = window): IViewportExtraAttrs {
        const doc: Document = viewport.document;
        return {
            viewportHeight: doc.documentElement.offsetHeight || doc.body.offsetHeight || 0,
            viewportWidth: doc.documentElement.offsetWidth || doc.body.offsetWidth || 0
        };
    }

    /**
     * 获取Viewport Box属性映射KV值。
     * @returns {IObjectMap<string>}
     */
    public static getViewportBoxAttrsMap(): IObjectMap<string> {
        return {
            viewportHeight: 'h',
            viewportWidth: 'w'
        };
    }
}
